export const SearchAlertCaseConstant = {
    CASE_SEARCH_INITIATED : "CASE_SEARCH_INITIATED",
    CASE_SEARCH_SUCCESS : "CASE_SEARCH_SUCCESS",
    CASE_SEARCH_FAILED : "CASE_SEARCH_FAILED", 
    CASE_UPDATE_URL_STATE : "CASE_UPDATE_URL_STATE", 
    CASE_UPDATE_SEARCHES: "CASE_UPDATE_SEARCHES", 
    CASE_NO_FILTER_ON_TYPE: "CASE_NO_FILTER_ON_TYPE", 
    CASE_CHANGE_PAGE: "CASE_CHANGE_PAGE"
} 